<icc-select-box
  [title]="'GARAGE_DOOR|Rodzaj sprężyn' | translate"
  [description]="(selectedMechanism$ | async)?.name"
  [imageUrl]="'/files/garagedoormechanism/' + (selectedMechanism$ | async)?.img"
  [buttonText]="'INTERFACE|Zmień' | translate"
  (select)="selectMechanism()"
></icc-select-box>

<icc-select-box
  [title]="'GARAGE_DOOR|Prowadzenie' | translate"
  [description]="(selectedGuidance$ | async)?.name"
  [imageUrl]="'/files/garagedoorguide/' + (selectedGuidance$ | async)?.img"
  [buttonText]="'INTERFACE|Zmień' | translate"
  (select)="selectGuidance()"
></icc-select-box>

<form class="dimensions-form" [formGroup]="dimensionsForm">
  @if ((selectedGuidance$ | async)?.is_high_guide) {
    <mat-form-field class="">
      <mat-label translate>GARAGE_DOOR|Prowadzenie od krawędzi nadproża (H)</mat-label>
      <input matInput #fieldValue iccDimensionInput step="5" type="number" formControlName="guidanceLift">
      @if ((fieldValue.value % 5 != 0)) {
        <mat-hint class="hint-danger">{{ 'GARAGE_DOOR|Wartość powinna być podzielna przez 5' | translate }}</mat-hint>
      }
      <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
    </mat-form-field>
  }
</form>